import React from 'react';
import styled from 'styled-components';
import { GlobalStyle } from '../global-style/global-style';
import GlobalHeader from '../global-header/global-header';
import AppConfig from '../../config/app-config';
import SceneManager from '../../scenes/scene-manager/scene-manager';
import Notifications from '../notifications/notifications';
import SplashPage from '../../config/customers/lower/components/SplashPage/SplashPage';

type AppViewProps = {
  isSplashPage: boolean;
  enableAnimations: boolean;
};

function AppView({
  enableAnimations, isSplashPage, ...props
}: AppViewProps) {
  return (
    <AppWrapper {...props}>
      {isSplashPage && enableAnimations && <SplashPage />}
      <GlobalStyle />
      <GlobalHeader />
      <SceneManager routes={AppConfig.Routes} />
      <Notifications />
    </AppWrapper>
  );
}

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100vh;

`;

export default AppView;
